<template>
  <div
    class="capsule-button-wrap"
    :style="{ '--item-expaned-width': expandWidth }"
    :class="[direction]"
  >
    <div
      class="capsule-button-item"
      :style="item.style"
      v-for="(item, index) in options"
      @click="item.onClick(item, $event)"
      :title="item.title"
      :key="index"
      :class="[{ open }]"
    >
      <div class="capsule-button-item_text">{{ item.text }}</div>
      <div class="capsule-button-item_icon" :style="item.iconStyle" :class="[item.icon]"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    firstPreview: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'right'
    },
    expandWidth: {
      type: String,
      default: '120px'
    },
    options: {
      type: Array,
      default: () => [{ text: 'text', icon: 'icon' }]
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    handleFirstPreview() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.open = true;

          setTimeout(() => {
            this.open = false;
          }, 2000);
        }, 1000);
      });
    }
  },
  mounted() {
    this.handleFirstPreview();
  }
};
</script>

<style lang="scss">
.capsule-button-wrap {
  --border-color: var(--capsule-border-color, rgba(73, 199, 195, 0.5));
  --wrap-padding: 7px 4px;
  --wrap-bg-color: var(--capsule-wrap-bg, #0c1620);

  --shadow-color: var(--capsule-shadow-color, rgb(73, 199, 195));

  --item-icon-size: 35px;
  --item-icon-font-size: 16px;
  --item-expaned-width: 120px;
  --item-text-icon-gap: 6px;
  --item-width: var(--item-icon-size);
  --item-height: var(--item-icon-size);

  --item-text-color: var(--capsule-text-color, #49c7c3);
  --item-bg-color: var(--capsule-item-bg, #0c1620);
  --item-hover-bg-color: var(--capsule-hover-bg, #0c1620);

  position: absolute;
  left: 0;
  top: 30%;
  z-index: 9;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--wrap-padding);

  width: calc(var(--item-icon-size));

  color: var(--item-text-color);
  font-size: 14px;

  background: var(--wrap-bg-color);

  box-shadow: 0 0 3px var(--shadow-color);
  // border: 1px solid var(--border-color);
  border-radius: 0 8px 8px 0;
  padding: var(--wrap-padding);

  .capsule-button-item {
    color: var(--item-text-color);
    background: var(--item-bg-color);

    position: relative;

    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;

    transition: width 0.4s;

    width: var(--item-icon-size);
    height: calc(var(--item-height));

    border-radius: 30px;

    cursor: pointer;
    overflow: hidden;
    box-shadow: 0 0 3px var(--shadow-color);

    &.open {
      width: var(--item-expaned-width);
    }

    &_icon {
      display: inline-block;
      width: var(--item-icon-size);
      height: var(--item-icon-size);

      font-size: var(--item-icon-font-size);
      text-align: center;
      line-height: var(--item-icon-size);

      box-shadow: 0 0 3px 1px var(--shadow-color);
      border-radius: 50%;
    }

    &:hover {
      width: var(--item-expaned-width);
      background-color: var(--item-hover-bg-color);
    }

    &_text {
      position: absolute;
      left: calc(var(--item-icon-size) + var(--item-text-icon-gap));

      width: calc(var(--item-expaned-width) - var(--item-icon-size) - var(--item-text-icon-gap));
      text-align: right;
    }
  }

  &.right {
    left: unset;
    right: 0;

    border-radius: 8px 0 0 8px;

    .capsule-button-item {
      flex-direction: row;

      position: relative;
      right: -100%;
      transform: translateX(-100%);

      &_text {
        left: unset;
        right: calc(var(--item-icon-size) + var(--item-text-icon-gap));
      }
    }
  }
}
</style>
